import { render, staticRenderFns } from "./TaskAreaCreateOrUpdate.vue?vue&type=template&id=852b0424&"
import script from "./TaskAreaCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TaskAreaCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports